export default __webpack_public_path__ + "static/media/259.69dc4258.png";